export enum FvmsMapApiVendor {
    KAKAO = "KAKAO"
    ,GOOGLE = "GOOGLE"
}
